import {spacing} from '../../_delonghi'
import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        outterContainer: {
            gap: remCalc(16),
            flexDirection: 'column',
        },
        container: {
            flexDirection: 'column',
            gap: remCalc(5),
        },
        title: {
            textStyle: 'body-small',
            fontWeight: 'bold',
        },
        termsAndConditionsContainer: {
            textStyle: 'body-xxsmall',
            alignItems: 'center',
            gap: spacing.xxsmall,
        },
        outterWarrantyItemContainer: {
            gap: {base: 'xxsmall.base', md: 'xxsmall.md', lg: 'xxsmall.lg', xl: 'xxsmall.xl'},
        },
        itemContainer: {
            bg: 'background.base.under',
            flexDirection: 'column',
            padding: {base: 'xsmall.base', md: 'xsmall.md', lg: 'xsmall.lg', xl: 'xsmall.xl'},
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 'large-1',
            gap: {base: 'xsmall.base', md: 'xsmall.md', lg: 'xsmall.lg', xl: 'xsmall.xl'},
        },
        itemContainerChecked: {
            bg: 'background.base.over',
            boxShadow:
                '0 0 0 1px var(--chakra-colors-border-neutral-highlight) inset, 0 1px 2px 0 var(--chakra-shadows-neutral-xs), 0 0 0 1px var(--chakra-shadows-neutral-xs)',
        },
        warrantyGroupHeaderContainer: {
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: {base: remCalc(4), lg: remCalc(0)},
            width: '100%',
        },
        warrantyGroupNameCheckboxContainer: {
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            width: '100%',
            gap: remCalc(4),
        },
        warrantyGroupName: {
            textStyle: 'body-small',
            fontWeight: 'medium',
            color: 'foreground.neutral.default',
        },
        warrantyGroupSubtitleContainer: {
            flexDirection: {base: 'column', lg: 'row'},
            alignItems: 'flex-start',
            width: '100%',
            gap: remCalc(4),
        },
        warrantyGroupSubtitle: {
            textStyle: 'body-small',
            fontWeight: 'regular',
            color: 'foreground.neutral.muted',
        },
        warrantyGroupLinkButton: {
            textStyle: 'body-small',
            fontWeight: 'regular',
            color: 'foreground.neutral.muted',
            textDecoration: 'underline',
            cursor: 'pointer',
        },
        warrantyOptionsContainer: {
            alignItems: 'center',
            gap: remCalc(8),
            flexDirection: 'row',
            justifyContent: 'space-between',
            width: '100%',
        },
        dropdown: {
            maxWidth: remCalc(288),
        },
        price: {
            textStyle: 'body-xsmall',
            fontWeight: 'medium',
        },

        //Modal
        modalContent: {
            bg: 'background.base.default',
            maxWidth: remCalc(437),
            marginX: {base: remCalc(16), lg: remCalc(0)},
        },
        modalHeader: {
            padding: {base: 'small.base', md: 'small.md', lg: 'small.lg', xl: 'small.xl'},
        },
        modalHeaderIconsContainer: {
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingY: remCalc(10),
        },
        modalHeaderIcon: {
            width: remCalc(16),
            height: remCalc(16),
            color: 'foreground.neutral.default',
        },
        modalHeaderCloseIcon: {
            width: remCalc(16),
            height: remCalc(16),
            color: 'foreground.neutral.default',
            cursor: 'pointer',
        },
        modalHeaderTextContainer: {
            flexDirection: 'column',
            gap: {base: 'xxsmall.base', md: 'xxsmall.md', lg: 'xxsmall.lg', xl: 'xxsmall.xl'},
        },
        modalHeaderTitle: {
            textStyle: 'body-medium',
            fontWeight: 'medium',
            color: 'foreground.neutral.default',
        },
        modalHeaderSubtitle: {
            textStyle: 'body-small',
            fontWeight: 'regular',
            color: 'foreground.neutral.muted',
        },
        modalBody: {
            padding: remCalc(0),
        },
        modalFeaturesContainer: {
            flexDirection: 'column',
            gap: {base: 'small.base', md: 'small.md', lg: 'small.lg', xl: 'small.xl'},
            paddingX: {base: 'small.base', md: 'small.md', lg: 'small.lg', xl: 'small.xl'},
        },
        modalFeature: {
            flexDirection: 'row',
            gap: {base: 'xsmall.base', md: 'xsmall.md', lg: 'xsmall.lg', xl: 'xsmall.xl'},
            alignItems: 'center',
        },
        modalFeatureIcon: {
            width: remCalc(20),
            height: remCalc(20),
            color: 'foreground.neutral.default',
        },
        modalFeatureTextContainer: {
            flexDirection: 'column',
            gap: {base: 'micro.base', md: 'micro.md', lg: 'micro.lg', xl: 'micro.xl'},
        },
        modalFeatureTitle: {
            textStyle: 'body-small',
            fontWeight: 'medium',
            color: 'foreground.neutral.default',
        },
        modalFeatureDescription: {
            textStyle: 'body-small',
            fontWeight: 'regular',
            color: 'foreground.neutral.muted',
        },
        modalFooter: {
            padding: {base: 'small.base', md: 'small.md', lg: 'small.lg', xl: 'small.xl'},
            justifyContent: 'flex-start',
        },
        modalFooterButton: {
            color: 'foreground.accent.default',
        },
        modalFooterButtonIcon: {
            width: remCalc(16),
            height: remCalc(16),
            color: 'foreground.accent.default',
        },
    },
}
